import { FieldType } from '@wix/wix-data-schema-types'
import {
  RADIOGROUP_ROLE,
  USER_INPUT_FILTER_RADIOGROUP_ROLE,
} from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const { text, date, dateTime, number, url, stringArray, reference } = FieldType

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_Radio_Button_Group',
  isConnectGfppEnabled: true,
  supportsDefaultSelectedDataset: true,
  panel: {
    height: 297,
    title: 'Connect_Panel_Title_Radio_Buttons',
    helpId: 'dc7fa632-fdc8-49b3-9fa7-393483d1d848',
    chooseScreenHelpId: 'c571b727-2098-4e86-8f56-60d4f36455ce',
    submitContentHelpId: '284fbe37-01a0-4922-9762-d0941e3ede55',
    userInputFilterHelpId: '2a263fcd-a797-4b03-85a9-6a1c04414e2c',
  },
  sections: [
    {
      role: RADIOGROUP_ROLE,
      bindings: [
        {
          title: 'Connect_Panel_Connect_Value_Label',
          prop: 'value',
          supportedFieldTypes: [text, number, url, date, dateTime],
          defaultFieldType: text,
          isInputProperty: true,
        },
      ],
    },
    {
      role: USER_INPUT_FILTER_RADIOGROUP_ROLE,
      isUserInputFilter: true,
      bindings: [
        {
          prop: 'value',
          supportedFieldTypes: [text, number, stringArray, reference],
          defaultFieldType: text,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId:
                'user_input_filters_live_preview_gfpp_desktop_main_action',
              label: 'User_Input_Filters_Live_Preview_GFPP_Desktop_Main_Action',
            },
          },
        },
        panel: {
          settings: {
            controls: {
              value: {
                hidden: true,
              },
              required: {
                hidden: true,
              },
            },
          },
        },
      },
      manageContentPanel: {
        isElementNamePlural: true,
      },
    },
  ],
  compactErrorPanel: true,
})
